import { AppSyncError } from "../../../core/utils/aws/appsync/AppSyncError.js";
import type { GlobalSettings } from "../GlobalSettings.js";

let sentryInitiated = false;
export async function initSentry({ SENTRY_DSN, ENV, VERSION }: GlobalSettings): Promise<void> {
	if (sentryInitiated || !import.meta.env.PROD) {
		return;
	}

	const Sentry = await import("@sentry/browser");
	Sentry.init({
		dsn: SENTRY_DSN,
		environment: ENV,
		release: VERSION,
		tracesSampleRate: 1.0,
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				maskAllText: false,
				maskAllInputs: false,
				blockAllMedia: false,
			}),
		],
		beforeSend(event, hint) {
			const exception = hint.originalException;

			if (exception instanceof AppSyncError) {
				event.fingerprint = ["{{ default }}", String(exception.name), String(exception.message)];
			}

			return event;
		},
	});

	// eslint-disable-next-line require-atomic-updates
	sentryInitiated = true;
}
